import { FC } from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import { CompaniesPieColors } from 'slices/modules/companies/companiesPieColors';

interface Props {
  clients: PeCompanyClient[];
  pieColors: CompaniesPieColors;
}

const PeClientsPieChart: FC<Props> = ({ clients, pieColors }) => {
  const pieSize = 208;

  return (
    <PieChart width={pieSize} height={pieSize}>
      <Pie
        data={clients}
        dataKey="volumePercent"
        nameKey="name"
        innerRadius={pieSize / 2 - 30}
        outerRadius={pieSize / 2}
      >
        {clients.map((entry, index) => (
          <Cell key={index} fill={pieColors[entry.name]} />
        ))}
      </Pie>
    </PieChart>
  );
};

export default PeClientsPieChart;
